import { render, staticRenderFns } from "./AnnotationWorkItem.vue?vue&type=template&id=d0723552&"
import script from "./AnnotationWorkItem.vue?vue&type=script&lang=js&"
export * from "./AnnotationWorkItem.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationWorkItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports